import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { getCurrentCompanyId } from "@/plugins/roles";
import api from "@/getinfo-api";
import { User as IUser } from "@/api/models/user";
import { MainList } from "@/classes/MainList";

export class EmployeesListClass extends MainList {
  params: EmployeeListParams = {
    id: getCurrentCompanyId(),
    userIds: undefined,
    roles: undefined,
    limit: 30,
    offset: 0
  };

  constructor(
    params?: EmployeeListParams,
    companyId?: string,
    employeeId?: string
  ) {
    super();
    this.dataLabel = "employees";
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    this.method = employee;
    if (companyId && employeeId) {
      this.singleMethod = () => api.EmployeeApi.get(companyId, employeeId);
      this.single();
    }
    this.list();
  }

  get users(): Array<IUser> {
    return this.listItems?.map(employee => employee.user);
  }

  get employees(): Array<IEmployee> {
    return this.listItems;
  }
}
